export const ENDPOINTS = {
  SEND_OTP: "/phone/login",
  VERIFY_OTP: "/phone/login/otp-validate",
  USER_DEVICE: "/users/device",
  REGISTER_FCM: "/users/fcm",
  BRANCH_TRAFFIC_DATA: "/users/traffic-data",
  SOURCE_ATTRIBUTION: "/lf/source/attribution",
  REFRESH_TOKEN: "/auth/refresh_token",
  GET_USER_STATUS: "/users/get_status",
  RETRY_REVALUATION: "/users/retry_revaluation",
  HOME: "/user/home?trg_ru=1",
  // Stage 1
  VERIFY_EMAIL: "/login/email_verify",
  SEND_MANUAL_EMAIL_OTP: "/email/manual-email-otp/send",
  VERIFY_MANUAL_EMAIL_OTP: "/email/manual-email-otp/verify",
  PROFILE_INFO: "users/profile",
  DROPDOWN_VALUES_API: "/stage2",
  INCOME: "/stage2/income",
  INCOME_MASTER_DATA: "/api/income/get_master_data",
  GET_ADDRESS_DROPDOWN_VALUES: "/stage1/get_current_address",
  ADDRESS: "/stage2/current_address",
  //stage 2
  GET_REFERENCE: "/get_references",
  SEND_REFERENCE_OTP: "/reference/send_otp",
  VERIFY_REFERENCE_OTP: "/reference/verify_otp",
  SKIP_REFERENCE: "/reference/skip_otp",
  UPDATE_REFERENCE_STATUS: "/reference/update_status",
  VKYC_GENERATE_URL: "/vkyc/generate-web-link",
  DIGILOCKER_GENERATE_URL: "/digilocker/kyc/initiate",
  DIGILOCKER_UPDATE: "/digilocker/kyc/details",
  HYPERVERGE_GENERATE_TOKEN: "/stage2/hyperverge/generate_token",
  HYPERVERGE_SUBMIT: "/stage2/hyperverge/submit",
  DOCS_FOR_REUPLOAD: "/users/docs_for_reupload",
  //State 3
  PRODUCT_DETAILS: "/user/product_details",
  GET_LOAN_AND_EMI_DETAILS: "/loan/application/details",
  GET_COUPON_LIST: "/coupons/list",
  APPLY_COUPON: "/coupons/apply",
  LOAN_PURPOSE: "/loanDetails/purpose",
  ADD_PURPOSE: "/loan/application/add",
  HYPERVERGE_UPDATE: "/stage2/hyperverge/update",

  // boosters
  STAGE4_REVALUATION: "/stage4/revaluation",
  BOOSTER_HOME: "/booster/home",
  GET_AMOUNT: "/stage4/get_amount",
  DECISION_MAKING: "/stage4/decision_making",
  // mobile auth
  MOBILE_AUTH: "/mobile_auth",
  GENERATE_MOBILE_AUTH_OTP: "/mobile_auth/generate-otp",
  VERIFY_MOBILE_AUTH_OTP: "/mobile_auth/verify-otp",
  // employment verification
  SEND_EMAIL_OTP: "/company_details/email_otp",
  RESEND_EMAIL_OTP: "/email/generate",
  VERIFY_EMPLOYMENT_EMAIL: "/email/verify",
  COMPANY_DETAILS: "/company_details",
  POST_EPFO_DETAILS: "/epfo/uan_advanced",
  // unified kyc ( digilocker )
  OKYC_CONSENT: "/okyc/consent",
  UNIFIED_KYC_GENERATE_URL: "/unified-kyc/generate-url",
  UNIFIED_KYC_REDIRECTION: "/unified-kyc/redirection",
  // current address stage4
  CURRENT_ADDRESS_DETAILS: "/current_address/details",

  // income verification
  GET_REQUIRED_PAYSLIPS_DATA: "/payslips",
  UPLOAD_PAYSLIPS: "/additional_documents/capture",
  GET_BANKS_STATEMENTS_DATA: "/bank_statement",
  UPLOAD_BANK_STATEMENT: "/bank_statement/capture",
  INCOME_VERIFICATION: "/digitap/incomevalidation/generateurl",
  DIGITAP_INCOME_UPDATE_STATUS: "/digitap/incomevalidation/update_status",

  // ckyc authentication
  CKYC_DOWNLOAD: "/central_kyc/stage4/download",
  CKYC_VALIDATE_OTP: "/central_kyc/stage4/validate_otp",
  CKYC_RESEND_OTP: "/central_kyc/stage4/resend_otp",
  CKYC_SKIP: "/central_kyc/stage4/skip",
  CKYC_DETAILS: "/central_kyc/stage4/get_details",
  CKYC_REVALUATE: "/central_kyc/stage4/revaluate",

  // stage 4
  GET_USER_BANK_DETAILS: "/user/getBanks",
  SEND_BANK_DETAILS: "/bank/details",
  GET_BANK_NAMES: "/bank/branch-lookup",
  GET_IFSC_CODE: "/bank/ifsc-lookup",
  PENNYDROP_CHECK: "/aadhar/bankVerify",
  LOAN_ADD: "/loan/add",
  GET_LOAN_SANCTION_LETTER: "/users/get-loan-sanction-letter",
  CANCEL_LOAN_APPLICATION: "/users/cancel-loan-sanction-letter",
  DOWNLOAD_ESIGN: "/digio/downloadEsign",
  ESIGN_AGREEMENT: "/storage/upload",
  ESIGN_SEND_OTP: "/otp_esign/send_otp",
  ESIGN_VALIDATE_OTP: "/otp_esign/validate_otp",
  ESIGN_RESEND_OTP: "/otp_esign/resend_otp",
  //stage 5
  REPAYMENT_DETAILS: "/repayments/loan-details",
  REPAYMENT_OPTIONS: "/repayments/options",
  ENACH_INITIATE: "/autodebit/initiate",
  ENACH_UPDATE: "/autodebit/update", //profile
  GET_USER_PROFILE: "/users/profile",
  LOAN_HISTORY: "/user/loans",
  CHECK_DELETE_ELIGIBITY: "/lf/delete_account",
  SEND_DELETE_PROFILE_OTP: "/lf/delete_account",
  VERIFY_DELETE_PROFILE_OTP: "/lf/delete_account/delete",
  DOWNLOAD_LOAN_DOCUMENT: "/getLoanDocs",
  CREDIT_REPORT_HISTORY: "/credit_type/history",
  CREDIT_REPORT_DETAILS_CRIF: "/crif/details",
  CREDIT_REPORT_DETAILS_EQUIFAX: "/equifax/details",
  DOWNLOAD_CREDIT_REPORT_CRIF: "/crif_b2c/get_report",
  DOWNLOAD_CREDIT_REPORT_EQUIFAX: "/equifax/get_report",
  SEND_CREDIT_REPORT_EMAIL_CRIF: "/crif_b2c/send_email",
  SEND_CREDIT_REPORT_EMAIL_EQUIFAX: "/equifax/send_email",
  CREDIT_REPORT_PAYMENT_OPTIONS: "/payments/options",
  PAYMENTS_INITIATE: "/payments/initiate",
  PAYMENTS_UPDATE: "/payments/update",
  UPLOAD_CHEQUE: "/bank/uploadCheque",
};
